/**
 * 路由跳转封装
 * - 业务层禁止直接 uni.navigateTo / redirectTo / switchTab 拼字符串
 * - query 自动序列化，兼容对象类型参数
 */

type Query = Record<string, string | number | boolean | undefined | null>

function buildUrl(path: string, query?: Query): string {
  if (!query) return path
  const search = Object.entries(query)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join('&')
  return search ? `${path}?${search}` : path
}

export function navigateTo(path: string, query?: Query): Promise<void> {
  return new Promise((resolve, reject) => {
    uni.navigateTo({
      url: buildUrl(path, query),
      success: () => resolve(),
      fail: (err) => reject(err),
    })
  })
}

export function redirectTo(path: string, query?: Query): Promise<void> {
  return new Promise((resolve, reject) => {
    uni.redirectTo({
      url: buildUrl(path, query),
      success: () => resolve(),
      fail: (err) => reject(err),
    })
  })
}

export function reLaunch(path: string, query?: Query): Promise<void> {
  return new Promise((resolve, reject) => {
    uni.reLaunch({
      url: buildUrl(path, query),
      success: () => resolve(),
      fail: (err) => reject(err),
    })
  })
}

export function switchTab(path: string): Promise<void> {
  return new Promise((resolve, reject) => {
    uni.switchTab({
      url: path,
      success: () => resolve(),
      fail: (err) => reject(err),
    })
  })
}

/**
 * 返回上一页；无足够页面栈时走 fallback（自定义 Tab 多用 redirectTo，H5 上常出现栈深为 1）。
 * fallback 先 redirectTo（轻量），失败再 reLaunch。
 */
export function navigateBack(delta = 1, fallback = '/pages/index/index'): void {
  const stack = typeof getCurrentPages === 'function' ? getCurrentPages() : []
  if (!stack.length || stack.length <= delta) {
    void redirectTo(fallback).catch(() => {
      void reLaunch(fallback)
    })
    return
  }
  uni.navigateBack({
    delta,
    fail: () => {
      void redirectTo(fallback).catch(() => {
        void reLaunch(fallback)
      })
    },
  })
}
